import React from "react";

export default function LoginAlert(props) {
    return (
        <>
            <div className={`transition-all fixed top-0 z-50 backdrop-blur-sm w-full h-screen  ${props.showLoginAlert ? "top-0" : "top-[2000px]"}`}>
                <div className=" bg-white shadow-sm p-4 ">
                    <p className="flex items-center justify-center gap-1 mb-4">
                        برای ادامه فرآیند وارد شوید
                    </p>
                    <div className="flex items-center justify-center gap-2 w-full">
                        {/* <button onClick={() => props.setShowLoginAlert(false)} */}
                        <button onClick={() => props.setShowLoginAlert(false)}
                            className={`opacity-100 pointer-events-auto border-main border text-main flex justify-center items-center gap-1.5 rounded rounded-lg px-3 py-1.5 w-1/3`}>
                            انصراف
                        </button>
                        <a onClick={() => props.setShowLoginAlert(false)} href="/LoginStepOne"
                            className={`opacity-100 pointer-events-auto bg-main text-white flex justify-center items-center gap-1.5 rounded rounded-lg px-3 py-1.5 w-1/3`}>
                            ثبت نام / ورود
                        </a>
                    </div>
                </div>
            </div>
        </>
    )
}